import { render, staticRenderFns } from "./OwnerInputForm.vue?vue&type=template&id=bff67b5a&scoped=true&"
import script from "./OwnerInputForm.vue?vue&type=script&lang=js&"
export * from "./OwnerInputForm.vue?vue&type=script&lang=js&"
import style0 from "./OwnerInputForm.vue?vue&type=style&index=0&id=bff67b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff67b5a",
  null
  
)

export default component.exports